/** Popup visual templates (storefront preview + editor). Legacy value 5 maps to template 3. */

export const POPUP_LAYOUT_OPTIONS = [
  {
    value: "1",
    label: "Template 1 — Split spotlight",
  },
  {
    value: "2",
    label: "Template 2 — Editorial hero",
  },
  {
    value: "3",
    label: "Template 3 — Midnight wave",
  },
  {
    value: "4",
    label: "Template 4 — Centered card",
  },
];

export function normalizePopupLayout(raw) {
  const s = String(raw ?? "1").trim();
  if (s === "5") return "3";
  if (s === "1" || s === "2" || s === "3" || s === "4") return s;
  return "1";
}
